import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs } from "@lk-gtcom/ecomlab-components";
import { TableBox } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../components/TitlePage/TitlePage';
import useGeneralStore from '../../store/general';
import customHeaders, { getSpace } from '../../common/headers';
import { useResponseHandler } from '../../common/auth';
import { useDataTable } from '../../common/hooks';
import { useRef } from 'react';
import { ModalAct } from './ModalAct/ModalAct';
import "./OfferAndContract.scss"

const tabBtn = [
    { label: 'Акты', value: 'act' },
    { label: 'Счета и фактуры', value: 'invoice' },
    { label: 'Договора', value: 'contract' },
]

const OfferAndContract = () => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const activeTab = useParams()['*']
    const [pageValue, setPageValue] = useState(tabBtn[0].value)

    const [isModalAct, setIsModalAct] = useState(false)
    const [selectedAct, setSelectedAct] = useState(null)

    // таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading, setFetchedData, setHeaders, setSort, setFilters } = setTableFuncs;

    // Таблицы
    const fetchTableData = (params, abortController = new AbortController()) => {

        setLoading(true)
        let sort;
        let filters;

        if (params) {
            [sort, filters] = params;
        }

        let url = `https://apps0.ecomru.ru:4420/api/v1/billing_invoice/table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''}`;

        const body = JSON.stringify({
            filters,
            page: paginatorRef.current.page,
            limit: paginatorRef.current.limit,
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((table) => setTable(table))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })
    };

    const onAction = (e) => {
        const num_act = e?.['Номер счета']
        setSelectedAct(num_act)
        setIsModalAct(true)
    }

    useEffect(() => {
        setPageValue(activeTab)
    }, [activeTab])


    useEffect(() => {
        const abortController = new AbortController();
        fetchTableData([], abortController);
        return () => abortController.abort();
    }, []);

    return (
        <>
            {isModalAct && <ModalAct
                setIsModal={setIsModalAct}
                selectedAct={selectedAct}
                setSelectedAct={setSelectedAct}
            />}

            <div className='offer-and-contract'>
                <TitlePage
                    title='Договора и отчетные документы'
                />
                <Tabs
                    tabs={tabBtn}
                    pageValue={pageValue} />

                <TableBox
                    {...tableProps}
                    ref={paginatorRef}
                    paginator={true}
                    fetchCallback={fetchTableData}
                    onAction={onAction}
                />
            </div>
        </>
    )
}

export { OfferAndContract }